export default {"src":"/_next/static/media/close-icon.420411a0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};